import { render } from "./AdminBooks.vue?vue&type=template&id=468bfecd"
import script from "./AdminBooks.vue?vue&type=script&lang=js"
export * from "./AdminBooks.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__